import SphConstants from 'sg-sph-constants';
import { SgProductService } from 'saga-modules';
import { SG_AA_FIELDS_ADDONS, SG_AA_PRODUCT_NAME, SG_AA_COVER_LEVELS } from '../AdobeAnalyticsConstants';

const legalExpenses = 'homeLegalExpensesCoverQuestion';

export default class SphAdobeAnalyticsUtil {
    static createPropertyDetailsData(propertyDetails) {
        let value;
        if (propertyDetails !== undefined) {
            if (propertyDetails.propertyCategory !== undefined && propertyDetails.numberOfBedrooms !== undefined
                && propertyDetails.approxYearBuild !== undefined && propertyDetails.moreThanQuarterRoofFlat !== undefined) {
                value = SphConstants.PROPERTY_DETAILS.FULL_DETAILS;
            } else if (propertyDetails.propertyCategory === undefined || propertyDetails.numberOfBedrooms === undefined
                || propertyDetails.approxYearBuild === undefined || propertyDetails.moreThanQuarterRoofFlat === undefined) {
                value = SphConstants.PROPERTY_DETAILS.PARTIAL_DETAILS;
            }
        } else {
            value = SphConstants.PROPERTY_DETAILS.NO_DETAILS;
        }
        return value;
    }

    static getAddonLevels(modelVM, addonPath, value) {
        const { propertyDetails } = modelVM.lobData.privateHome.coverables;
        let coverLevel;
        if (addonPath === SphConstants.HOME_ADDONS.HasSheCover || addonPath === SphConstants.HOME_ADDONS.HasHeatingCover
            || addonPath === SphConstants.HOME_ADDONS.HasBoilerCover) {
            if (propertyDetails.hasSheCover) {
                if (propertyDetails.hasSheCover.value === true) {
                    coverLevel = 1;
                    if (propertyDetails.hasHeatingCover && propertyDetails.hasHeatingCover.value) {
                        coverLevel = 2;
                        if (propertyDetails.hasBoilerCover && propertyDetails.hasBoilerCover.value) {
                            coverLevel = 3;
                        }
                    } else if (propertyDetails.hasBoilerCover && propertyDetails.hasBoilerCover.value) {
                        coverLevel = 4;
                    }
                } else if (propertyDetails.hasSheCover.value === false) {
                    coverLevel = 0;
                }
            }
        }
        if (addonPath === SphConstants.HOME_ADDONS.UnspecifiedItemsCover && value.code !== SphConstants.NONE_PREFIX) {
            coverLevel = value.code;
        }
        return coverLevel;
    }

    static getAddonPath(cover) {
        let addonPath;
        if (cover === SphConstants.HOME_ADDONS.HasLegalCover) {
            addonPath = legalExpenses;
        } else if (cover === SphConstants.HOME_ADDONS.HasHeatingCover) {
            addonPath = SphConstants.HOME_ADDONS.HasSheCover;
        } else if (cover === SphConstants.HOME_ADDONS.HasBoilerCover) {
            addonPath = SphConstants.HOME_ADDONS.HasSheCover;
        } else {
            addonPath = cover;
        }
        return addonPath;
    }

    static isSelected(value, cover, modelVM) {
        const { propertyDetails } = modelVM.lobData.privateHome.coverables;
        if (cover === SphConstants.HOME_ADDONS.HasHeatingCover || cover === SphConstants.HOME_ADDONS.HasBoilerCover) {
            if (propertyDetails.hasSheCover && propertyDetails.hasSheCover.value === true) {
                return true;
            }
        }
        if (cover === SphConstants.HOME_ADDONS.UnspecifiedItemsCover) {
            return value.code !== SphConstants.NONE_PREFIX;
        }

        return value;
    }

    static determineProductName(propertyVM) {
        const { propertyUse } = propertyVM;
        const contentsSumInsured = propertyVM.contentsTotal && propertyVM.contentsTotal.amount;
        const rebuildCost = propertyVM.rebuildCost && propertyVM.rebuildCost.amount;

        if (propertyUse === SphConstants.PROPERTY_USE_CODES.Let) {
            return SG_AA_PRODUCT_NAME.LANDLORD;
        }
        if (propertyUse === SphConstants.PROPERTY_USE_CODES.LetHolidayHome) {
            return SG_AA_PRODUCT_NAME.HOLIDAY;
        }
        if (propertyUse === SphConstants.PROPERTY_USE_CODES.FamilyHolidayHome) {
            return SG_AA_PRODUCT_NAME.FAMILY;
        }
        if (propertyUse === SphConstants.PROPERTY_USE_CODES.WeekendHome) {
            return SG_AA_PRODUCT_NAME.WEEKEND;
        }
        if (rebuildCost > SphConstants.SG_HOME_TAILORMADE_LIMITS.REBUILD_COST
            || contentsSumInsured > SphConstants.SG_HOME_TAILORMADE_LIMITS.CONTENTS) {
            return SG_AA_PRODUCT_NAME.TAILORMADE;
        }
        return SG_AA_PRODUCT_NAME.STANDARD;
    }

    static determineProduct(isSagaPlus) {
        let productName = `${SgProductService.getInsuranceProductName()} - `;
        productName += isSagaPlus ? SG_AA_COVER_LEVELS.PLUS.toLowerCase() : SG_AA_COVER_LEVELS.SELECT.toLowerCase();
        return productName;
    }

    static unspecifiedItemValueMap(submission) {
        let key;
        if (submission.lobData.privateHome.coverables.propertyDetails.unspecifiedItemsCover) {
            if (submission.lobData.privateHome.coverables.propertyDetails.unspecifiedItemsCover !== SphConstants.NONE_PREFIX) {
                key = submission.lobData.privateHome.coverables.propertyDetails.unspecifiedItemsCover;
            }
        }
        return key;
    }

    static sheValueMapOnResume(submission) {
        const { propertyDetails } = submission.lobData.privateHome.coverables;
        let key;
        if (propertyDetails.hasSheCover) {
            key = 1;
            if (propertyDetails.hasHeatingCover) {
                key = 2;
                if (propertyDetails.hasBoilerCover) {
                    key = 3;
                }
            } else if (propertyDetails.hasBoilerCover) {
                key = 4;
            }
        } else if (!propertyDetails.hasSheCover) {
            key = 0;
        }
        return key;
    }

    static createClaimsTrackingObject(claim) {
        return {
            claimType: claim.type,
            claimCost: claim.cost.amount,
            claimReason: claim.reason
        };
    }

    static setArray(array) {
        return array && array.length ? array : undefined;
    }

    static getHomeCoverLevel(coverLevelCode) {
        // eslint-disable-next-line radix
        return coverLevelCode ? parseInt(coverLevelCode.slice(-1)) : 0;
    }

    static createSpecifiedItemsTrackingObject(specItem) {
        return {
            category: specItem.category,
            description: specItem.description,
            value: specItem.cost,
            awayFromHome: specItem.awayFromHome !== undefined && !specItem.isAwayFromHomePreSelected
                ? `${specItem.awayFromHome}` : SphConstants.NOT_AVAILABLE
        };
    }

    static buildUnspecifiedItemAdobeCoverage(value) {
        const addon = {
            name: SG_AA_FIELDS_ADDONS.unspecifiedItemsCover.name,
            amount: { amount: undefined },
            valueMap: value !== false ? SG_AA_FIELDS_ADDONS.unspecifiedItemsCover.valueMap[value] : undefined,
            selected: value !== false
        };
        return addon;
    }

    static addonFieldMap() {
        return {
            hasContentsAccidentCover: SG_AA_FIELDS_ADDONS.hasContentsAccidentCover,
            hasBuildingsAccidentCover: SG_AA_FIELDS_ADDONS.hasBuildingsAccidentCover,
            unspecifiedItemsCover: SG_AA_FIELDS_ADDONS.unspecifiedItemsCover,
            hasLegalCover: SG_AA_FIELDS_ADDONS.homeLegalExpensesCoverQuestion,
            hasSheCover: SG_AA_FIELDS_ADDONS.hasSheCover,
            hasBoilerCover: SG_AA_FIELDS_ADDONS.hasSheCover,
            hasHeatingCover: SG_AA_FIELDS_ADDONS.hasSheCover
        };
    }
}
